import React from "react";
import SectorDemoTemplate from "./demos/SectorDemoTemplate";
import { SECTOR_CONFIGS } from "./demos/sectorConfigs";

const DemoHair = () => <SectorDemoTemplate cfg={SECTOR_CONFIGS.hair} />;

export default DemoHair;
